import { Card } from "react-bootstrap";
import * as React from 'react';
import { translateService } from "../../services/TranslateService";
import Translate from 'react-translate-component';
import { IVehicleSearch } from "../../interfaces/VehicleSearch";
import styles from "./VehicleSearch.module.scss";
import Tippy from "@tippyjs/react";
import VehicleDetails from "./VehicleDetails";
import { useSelector } from "react-redux";
import { baseOnSalesPrice, basePrice, discountValue as calculateDiscountValue } from "../MakeReservation/pricingCalculations";
import { cx, priceFormat } from "../MakeReservation/util";
import { useInView } from "react-intersection-observer";
import {GlobalStore} from "../../reduxStore";
import {useSearchParams} from "react-router-dom";
import {VehicleImageSwiper} from "./VehicleImageSwiper";
import {useContext, useEffect, useState} from "react";
import {DataContext} from "../../contexts/dataContext";
import {Button} from "@mui/material";
import Modal from "react-modal";
import moment from "moment";
import axios from "axios";
import CalendarComponent from "./reservedTable";
import {Rating} from "@mui/material";
import {VipCodeVehicles} from "./VipCodeVehicles";

type SetDetailsVisibleFunctionI = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
interface VehicleResultProps {
  vehicle: IVehicleSearch;
  selectVehicle: Function;
  setRedirect: Function | null;
  totalPrice?: number;
  detailsVisible:boolean;
  setDetailsVisible: SetDetailsVisibleFunctionI;
  discountValue?: number;
  displaySticky?: boolean
  setBusy?: Function;
  discount?: null |  number;
  stars?: number
}

interface PriceDisplayProps {
  totalPrice: number;
  discount: number ;
  displaySticky: boolean;
  available?: boolean;
  children?: React.ReactNode;
}

const customStyles = {
  content: {
    width: '80%',
    top: '55%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'rgba(0,0,0,0.7)',
    color: 'white',
  },
  overlay: {
    zIndex: '20',
  },
};

export const PriceDisplay = ({totalPrice, discount, displaySticky=false, available=true, children}:PriceDisplayProps) => {
  return <>
    <div className={cx(displaySticky ? 'flex-column align-items-center justify-content-center' : 'flex-column align-items-center justify-content-center', 'd-flex justify-content-around ')} style={{width: 'fit-content'}}>
      {children}
      {(discount > 0 ) &&
          <div className={cx(styles.priceH4,styles.preferDiscountPrice)}>
            {priceFormat(totalPrice)} €
          </div>}
      <div className={styles.priceH4}>
        {!available ?
            <span style={{fontSize: '20px'}}><Translate content='vehicleSearch.reserved' /></span>
            :
            discount ?
                priceFormat(totalPrice-discount)+' € '
                :
                priceFormat(totalPrice)+' € '
        }
      </div>
      <div className={styles.includeVat}>
        <Translate with={{ type: moment().isBefore('2024-09-01') // before 1st Sept 2024 --> 24%, else 25.5% VAT
              ? translateService.translate('vehicleSearch.vatPercent24') :
              translateService.translate('vehicleSearch.vatPercent25')}}
                   content='vehicleSearch.vatIncluded'  />
      </div>
    </div>
  </>
}

const VehicleResult = (({ stars, vehicle, selectVehicle, totalPrice = vehicle.onsale ? baseOnSalesPrice(vehicle) : basePrice(vehicle), detailsVisible,
                          setDetailsVisible, discountValue=calculateDiscountValue(vehicle!), setRedirect=null, displaySticky=false, setBusy}: VehicleResultProps) => {
  const dataContext = useContext(DataContext);
  const language = useSelector((state: GlobalStore) => state.chauffeurReducer.deviceLanguage);
  const reserved = !vehicle.availabilityData?.available;
  const [refFromScroll, refFromScrollVisible] = useInView();
  const coupon = useSelector((s: GlobalStore ) => s.chauffeurReducer.coupon);
  const couponValid = !!coupon?.valid && vehicle.pricingData.coupon && !vehicle.onsale && vehicle.extraOnsales?.extra !== 1;
  let discount = couponValid ? discountValue : 0
  let price = totalPrice;
  const isVipVehicle = vehicle.privateData?.private;
  const [vipCodeValid, setVipCodeValid] = useState<boolean>(false);
  const [vipCodeCheckOpen, setVipCodeCheckOpen] = useState(false);
  const [reservationTable, setReservationTable] = React.useState<boolean>(false)
  const [reservedSlots, setReservedSlots] = React.useState<any>();

  Modal.setAppElement('body');

  useEffect(() => {
    if(dataContext.searchParameters?.carId !== null){
      selectVehicle(vehicle)
    }
  },[dataContext.searchParameters?.carId])

  const handleDatePicker = () => {
    reservationArr(vehicle.id)
    if (reservationTable) {
      setReservationTable(false)
    } else {
      setReservationTable(true);
      if (!dataContext.oneWayRes) {
        dataContext.sendGaEvent('searchCars', 'openCalendar', '', 0);
      } else {
        dataContext.sendGaEvent('searchCars', 'openOneWayCalendar', '', 0);
      }
    }
  }

  const reservationArr = async(vehicleId: number) => {
    // parameters axios get
    const start = moment(dataContext.searchParameters?.startDate).format('YYYY-MM-DD')
    const end = moment(dataContext.searchParameters?.endDate).format('YYYY-MM-DD')

    const params = {
      startDate: start,
      startTime: dataContext.searchParameters?.startTime,
      endDate: end,
      endTime: dataContext.searchParameters?.endTime,
    }

    try{
      // axios get
      if(vehicleId && params) {
        const response = await axios.get(`${dataContext.v3ApiUrl}/anonymous/vehicles/${vehicleId}/free-intervals`, {params})
        setReservedSlots(response.data.data);
      }
    } catch (e){
      console.log(e)
    }
  }

  if (vehicle.onsale) {
    discount =  ((1.0-vehicle.onsale.discountmultiplier)*vehicle.onsale.price)/100;
  }

  if ((vehicle.vehicleModelData.ageLimit ?? 18 ) > 18) {
    vehicle.vehicleData.noundertwentyone = true;
  } else {
    vehicle.vehicleData.noundertwentyone = false;
  }

  let fuelType: string;
  if (+vehicle.vehicleData.fuelType === 0)
    fuelType = translateService.translate('vehicleSearch.diesel');
  else if (+vehicle.vehicleData.fuelType === 1)
    fuelType = translateService.translate('vehicleSearch.95E');
  else
    fuelType = translateService.translate('vehicleSearch.electric');

  if (vehicle.vehicleData.hybridity === 'normal')
    fuelType += " - "+ translateService.translate('vehicleSearch.hybrid');
  else if (vehicle.vehicleData.hybridity !== 'none')
    fuelType += " - "+ translateService.translate('vehicleSearch.plugin');

  useEffect(() => {
    if(isVipVehicle && dataContext.validatedVipVehicles && dataContext.validatedVipVehicles.length) {
      if (dataContext.validatedVipVehicles.split(',').includes(vehicle.id.toString())){
        discount = 0; // additional discount not available with vip code
        setVipCodeValid(true);
      }
    }
  }, [isVipVehicle, dataContext.validatedVipVehicles, discount])

  const changeTwentyModal = () => {
    dataContext.changeTwentyModal(true)
    if(dataContext.twentyModal){
      dataContext.changeTwentyModal(false)
    }
  }

  function calculatePercentageRange(value:number) {
    // Ensure the value is within the range [0, 100]
    const clampedValue = Math.min(100, Math.max(0, value));
    const roundedValue = Math.round(clampedValue / 20); // return value 0-5
    return roundedValue;
  }

  return <>
    {/*VIP*/}
    <VipCodeVehicles isVipVehicle={isVipVehicle ?? false}
                     setVipCodeValid={setVipCodeValid}
                     vehicle={vehicle} selectVehicle={selectVehicle}
                     vipCodeCheckOpen={vipCodeCheckOpen} setVipCodeCheckOpen={setVipCodeCheckOpen}
                     discount={discount}/>
    {/*Display Sticky Pricing Banner*/}
    {(displaySticky && !refFromScrollVisible ) &&
        <div className={cx(styles.stickyPriceClass, styles.carPriceGreenBackground)}>

          <PriceDisplay totalPrice={price} discount={discount} displaySticky={true} available={vehicle.availabilityData?.available} >
            { vehicle.privateData?.vip && couponValid ?
                <div className={styles.vipPriceDisclaimer}>
                  {translateService.translate('vehicleSearch1.vipPriceDisclaimer')}
                </div> : null}
          </PriceDisplay>
        </div>
    }
    <div className={'w-100'}>
      {/* Vehicle Card */}
      <Card className={`card-body mb-3`} style={{padding: "10px"}}>
        <div className={'d-flex flex-lg-row flex-md-row flex-column'}>
          {/* Image Container */}
          <div className={`col-12 col-md-4 col-lg-4 px-0`} style={{height: "170px"}}>
            {/* Images*/}
            <VehicleImageSwiper vehicle={vehicle}/>
            {/*Reserved Banner*/}
            {reserved &&
                <div className={styles.carReserved}>
                  <div className={styles.label} style={{ fontSize: '10px' }}>
                    <Translate content='vehicleSearch.reserved' />
                  </div>
                </div>
            }
            {/* OneWay */}
            {(!dataContext.oneWayRes && !vehicle.pricingData.withCoupon && vehicle.pricingData.base.unlimitedKilometers !== null &&
                    vehicle.pricingData.base.unlimitedKilometers < 1001 && !reserved) &&
                <div className={styles.discountRibbon}>
                  <div className={styles.label}>
                    <Translate content='vehicleSearch.unlimited' /> km {vehicle.pricingData?.base.unlimitedKilometers / 100} €/<Translate content='vehicleSearch.day' />
                  </div>
                </div>
            }
            {(!dataContext.oneWayRes && !vehicle.pricingData.withCoupon && vehicle.pricingData.base.unlimitedKilometers !== null &&
                    vehicle.pricingData.base.unlimitedKilometers > 1000 &&
                    vehicle.pricingData.base.additionalDriver !== 0 && !reserved) &&
                <div className={styles.discountRibbon}>
                  <div className={styles.label}>
                    <Translate content='vehicleSearch.unlimited' /> km {vehicle.pricingData?.base.unlimitedKilometers / 100} €/<Translate content='vehicleSearch.day' />
                  </div>
                </div>
            }
            {(!dataContext.oneWayRes && !vehicle.pricingData.withCoupon && vehicle.pricingData.base.additionalDriver === 0 &&
                    !(vehicle.pricingData.base.unlimitedKilometers < 1001) && !reserved) &&
                <div className={styles.discountRibbon}>
                  <div className={styles.label}>
                    <Translate content='vehicleSearch.additionalDriver' />  0 €/<Translate content='vehicleSearch.day' />
                  </div>
                </div>
            }
          </div>
          {/* Details Container */}
          <div className={'col-12 col-md-8 col-lg-8 mt-sm-2 pl-lg-2 pl-md-2 px-0 '}>
            <div className={`${styles.carModel} d-flex align-items-center justify-content-between flex-row`}>
              {/* Title */}
              <div>
                {vehicle.vehicleModelData.manufacturer} {vehicle.vehicleModelData.name} {vehicle.vehicleModelData.dimensions.trunkVolume !== 0 ?
                  vehicle.vehicleModelData.dimensions.trunkVolume + ' m³' : ''}
              </div>
              {/* Stars */}
              <div>
                {stars ?
                    <Tippy className="tooltip-link" zIndex={2}
                           content={translateService.translate('vehicleSearch1.starsTooltip')}>
                      <div className={'d-flex'}>
                        <Rating name="read-only"
                                max={1} // change this to display more stars
                                value={calculatePercentageRange(stars ? stars : 0)}
                                readOnly />
                        <span>{stars / 20}</span>
                      </div>
                    </Tippy >
                    : null}
              </div>
            </div>
            {/* Details with price container */}
            <div className={'d-flex flex-column-reverse flex-md-row-reverse flex-lg-row-reverse align-content-center align-items-center justify-content-between'}>
              <div className={'align-self-baseline banner-label col-12 col-md-4 col-lg-4 px-0'}>
                {/* Reserved */}
                {!reserved ?
                    <div className={`${cx(styles.r24ChildFlex1)} m-0`} ng-show="model.onSalesPrice == 0">
                      {/*TODO*/}
                      <div ref={refFromScroll} className={cx(styles.carPriceGreenBackground)}>
                        <PriceDisplay totalPrice={price} discount={discount} displaySticky={false} available={true}>
                          { vehicle.privateData?.vip && couponValid ?
                              <div className={styles.vipPriceDisclaimer}>
                                {translateService.translate('vehicleSearch1.vipPriceDisclaimer')}
                              </div> : null}
                          {discount && !reserved ?
                              <div className={`${cx(styles.couponRibbon)}`} style={{fontSize:'13px'}}>
                                <strong>
                                  <span><Translate content={'vehicleSearch.discount'}/></span>
                                  &nbsp;{priceFormat(discount)}<span>€</span>
                                </strong>
                              </div> : null
                          }
                        </PriceDisplay>
                      </div>
                      <div className={'d-flex justify-content-center align-items-center flex-column w-100'}>
                        {vehicle.pricingData.base.savingOpportunities.length ?
                            <Tippy
                                className="tooltip-link" zIndex={2}
                                content={vehicle.pricingData.base.savingOpportunities}>
                              <label className={'m-0 w-100 text-center'}
                                     style={{color: '#0BB395', fontSize: '13px'}}>{translateService.translate('vehicleSearch1.cheaper')}</label>
                            </Tippy>
                            : null
                        }
                      </div>
                    </div>
                    :
                    <div className={cx(styles.r24ChildFlex1, styles.r24LeftMargin5)} ng-show="model.onSalesPrice == 0">
                      <div ref={refFromScroll} className={cx(styles.carPriceGreenBackground)}>
                        <PriceDisplay totalPrice={price} discount={discount} displaySticky={false} available={false}/>
                      </div>
                    </div>
                }
              </div>
              <div className={'pr-2 pl-0 col-12 col-md-8 col-lg-8'}>
                <div className={styles.carModelNeighborhood}>{vehicle.homeLocationData.neighborhood}</div>
                <div className={styles.infoContainer}>
                  {vehicle.privateData?.private && !vipCodeValid ?
                      <div className={styles.vipAddressContainer}>
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + '/assets/icons/new/icon-reservation-location-gray.svg'}
                             alt="icon-reservation-location-gray" loading="lazy"/>
                        <span className={styles.vipBlockedAddress}> {dataContext.language === "fi" ? vehicle.privateData.messageFi : vehicle.privateData.messageEn} </span>
                      </div>
                      : <div className={styles.addressContainer}>
                        {!dataContext.oneWayRes ?
                            <span className='d-flex flex-row'>
                          <img width="23" height="23" className={`${styles.carFeatureIcon} `}
                               src={dataContext.rootUrl + '/assets/icons/new/map-pin-icon.svg'}
                               alt="ap-pin-icon" loading="lazy"/>
                          <div className={'text-wrap'}>
                            <span onClick={(e) => {
                              let marker = dataContext.mapMarkers.find((marker) => marker.vehicleId === vehicle.id);
                              if(marker){
                                marker.marker.click();
                              }
                            }}
                                  className={styles.carAddress}> {!dataContext.outOfRange ? vehicle.homeLocationData.fullAddress :
                                vehicle.homeLocationData.neighborhood + ' ' + vehicle.homeLocationData.city + ' ' + vehicle.homeLocationData.postalCode} {Math.round((+vehicle.distance / 1000) * 10) / 10} km</span>
                          </div>
                        </span>
                            :
                            <div className={styles.onewayAddresses}>
                          <span className='d-flex flex-row'>
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + '/assets/icons/new/search/icon-pickup-location.svg'}
                                 alt="icon-pickup-location" loading="lazy"/>
                            <div className={'text-wrap'}>
                               <span onClick={(e) => {
                                 let marker = dataContext.mapMarkers.find((marker) => marker.vehicleId === vehicle.id);
                                 if(marker){
                                   marker.marker.click();
                                 }
                               }}
                                     className={styles.carAddress}> {!dataContext.outOfRange ? vehicle.homeLocationData.fullAddress :
                                   vehicle.homeLocationData.neighborhood + ' ' + vehicle.homeLocationData.city + ' ' + vehicle.homeLocationData.postalCode} {Math.round((+vehicle.distance / 1000) * 10) / 10} km</span>
                            </div>
                          </span>
                              <span>
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + '/assets/icons/new/search/icon-return-location.svg'}
                                 alt="icon-return-location" loading="lazy"/>
                            <span onClick={(e) => {
                              dataContext.changeShowOneWayReturnLocation(vehicle.id);
                            }}
                                  className={styles.carAddress}>{!dataContext.outOfRange ? vehicle.returnLocationData?.fullAddress :
                                vehicle.returnLocationData?.neighborhood + ' ' + vehicle.returnLocationData?.city + ' ' + vehicle.returnLocationData?.postalCode}</span>
                          </span>
                            </div>
                        }
                      </div>}
                  <div>
                    {vehicle.parkingPermit.valid &&
                        <>
                          <div className={styles.r24Parking}>
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + "/assets/icons/new/search/icon-z-parking-permit.svg"}
                                 alt="icon-z-parking-permit" loading="lazy"/>
                            <span className={styles.r24ParkingTxt}> <Translate content={'vehicleSearch.freeParking'}/>{' '}{vehicle.vehicleData.parkingPermitCityName}</span>
                            <a className={`btn btn-sm btn-outline-info ${styles.greenReadMoreButton}`} target="_blank"
                               rel="noopener noreferrer"
                               style={{fontSize: '13px'}}
                               href={language === 'fi' ? "https://www.24rent.fi/pysakointi-z-luvalla/" :
                                   "https://www.24rent.fi/en/parking-with-parking-permit-z/"}>
                              <strong><Translate content={'vehicleSearch.readMore'}/>...</strong>
                            </a>
                          </div>

                        </>}
                  </div>
                  {/*Icons*/}
                  <div>
                    <div className={styles.iconAndText}>
                      <Tippy
                          className="tooltip-link"
                          zIndex={2}
                          content={<Translate content={'vehicleSearch.numberOfSeats'}/>}
                      >
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-seats.svg"}
                             alt="icon-car-feature-seats" loading="lazy"/>
                      </Tippy>
                      <span className={styles.baseIconMargin}>{vehicle.vehicleData.seatCount}</span>
                    </div>
                    <div className={styles.iconAndText}>
                      <Tippy
                          className="tooltip-link"
                          zIndex={2}
                          content={<Translate content={'welcomePhase.vehicleInfoModal.transmission'}/>}
                      >
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-gears.svg"}
                             alt="icon-car-feature-gears" loading="lazy"/>
                      </Tippy>
                      <span className={styles.baseIconMargin}>
                    {!vehicle.vehicleData.hasAutomaticTransmission ? <Translate content={'vehicleSearch.manual'}/> :
                        <Translate content={'vehicleSearch.automatic'}/>}
                  </span>
                    </div>
                    <div className={styles.iconAndText}>
                      <Tippy
                          className="tooltip-link"
                          zIndex={2}
                          content={<Translate content={'welcomePhase.vehicleInfoModal.fuel'}/>}
                      >
                        <img width="23" height="23" className={styles.carFeatureIcon}
                             src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-fuel.svg"}
                             alt="icon-car-feature-fuel" loading="lazy"/>
                      </Tippy>
                      <span className={styles.baseIconMargin}>
                    {fuelType}
                        {(vehicle.vehicleData.hybridity === 'normal' || vehicle.vehicleData.hybridity === 'plug-in' || +vehicle.vehicleData.fuelType === 2) &&
                            <span className={styles.r24EcoText}> ECO</span>
                        }
                  </span>
                    </div>
                    {vehicle.vehicleData.hasHandtruck &&
                        <div className={styles.iconAndText}>
                          <Tippy
                              className="tooltip-link"
                              zIndex={2}
                              content={<Translate content={'vehicleSearch.handtruck'}/>}
                          >
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-handtruck.svg"}
                                 alt="icon-car-feature-handtruck" loading="lazy"/>
                          </Tippy>
                          <span className={styles.baseIconMargin}> <Translate
                              content={'vehicleSearch.handtruck'}/> </span>
                        </div>
                    }

                    {vehicle.vehicleData.hasHitch &&
                        <div className={styles.iconAndText}>
                          <Tippy
                              className="tooltip-link"
                              zIndex={2}
                              content={<Translate content={'vehicleSearch.towingHitch'}/>}
                          >
                            <img width="23" height="23" className={styles.carFeatureIcon}
                                 src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-towbar.svg"}
                                 alt="icon-car-feature-towbar" loading="lazy"/>
                          </Tippy>
                          <span className={styles.baseIconMargin}> {vehicle.vehicleData.hitchPinCount} - <Translate
                              content={'vehicleSearch.pins'}/></span>
                        </div>
                    }
                    {vehicle.vehicleData.noundertwentyone ?
                        <>
                          <div className={styles.iconAndTextUnder21} onClick={() => changeTwentyModal()}>
                            <Tippy
                                className="tooltip-link"
                                zIndex={2}
                                content={<Translate content={'vehicleSearch.noundertwentyone'}/>}
                            >
                              <img width="35" height="35" style={{width: '35px', height: '35px'}}
                                   src={dataContext.rootUrl + "/assets/icons/new/car-feature-icons/icon-car-feature-noundertwntyone.svg"}
                                   alt={translateService.translate('vehicleSearch.noundertwentyone')} loading="lazy"/>
                            </Tippy>
                          </div>
                        </> : null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <VehicleDetails vehicle={vehicle} detailsVisible={detailsVisible} setDetailsVisible={setDetailsVisible}>
          {(setRedirect && !reserved && dataContext.route !== '/makereservation') ?
              !isVipVehicle || vipCodeValid ?
                  <button onClick={() => {
                    !dataContext.oneWayRes ? dataContext.sendGaEvent('reservation', 'beginReservation', '', 0) :
                        dataContext.sendGaEvent('reservation', 'beginOneWayReservation', '', 0);
                    selectVehicle(vehicle);
                  }}
                          className="btn btn-primary btn-outline-primary w-100 align-self-end rounded-3 font-weight-bold text-uppercase">
                    <Translate content={'vehicleSearch.selectCar'}/>
                  </button>
                  :
                  <button onClick={() => {
                    setVipCodeCheckOpen(!vipCodeCheckOpen)
                  }} className="btn btn-primary btn-outline-primary w-100 align-self-end rounded-3 font-weight-bold text-uppercase">
                    <Translate content={'vehicleSearch1.privateSelection'}/>
                  </button>
              : null}
          {reserved &&
              <button className="btn btn-primary btn-outline-primary w-50 align-self-end w-100"
                      onClick={handleDatePicker} id='check-available-times'>
                <Translate content={'vehicleSearch1.reservedSearch'}/>
              </button>}
        </VehicleDetails>
        {reservationTable && <Modal isOpen={reservationTable} style={customStyles}>
          <div>
            <div className={'row'} style={{width: 'inherit', marginTop: "5px", height: '100%'}}>
              <div className={'col-6'}></div>
              <div className={'col-6 d-flex justify-content-end mb-3'}>
                <button className='btn btn-sm btn-primary'
                        onClick={() => {handleDatePicker()}}> X </button>
              </div>
            </div>
            <CalendarComponent freeSlots={reservedSlots}/>
          </div>
        </Modal>
        }
      </Card>
    </div>
  </>
});

export default VehicleResult;
